import React from "react"
import PropTypes from "prop-types"
import * as Sentry from "@sentry/nextjs"

// Material UI
import { MuiThemeProvider } from "@material-ui/core/styles"
import { CssBaseline } from "@material-ui/core"
import theme from "themes/default"

// Global CSS component
import GlobalCss from "GlobalCss"
import { GA } from "utils/googleAnalytics"
import { getAuthInfo } from "shared/helpers"
import { trackUser } from "shared/helpersTs"
import { webengage } from "webengage"

function MyApp(props) {
  const { Component, pageProps } = props

  React.useEffect(() => {
    // Remove the server-side injected CSS.
    const jssStyles = document.querySelector("#jss-server-side")
    if (jssStyles) {
      jssStyles.parentElement.removeChild(jssStyles)
    }

    GA.init()

    const authInfo = getAuthInfo()
    if (authInfo) {
      trackUser(authInfo)
    }
  }, [])

  React.useEffect(() => {
    const WEBENGAGE_KEY = process.env.REACT_APP_WEBENGAGE_LICENSE_CODE
    const IS_LOCAL = process.env.NODE_ENV === "development"

    if (WEBENGAGE_KEY) {
      webengage?.init(WEBENGAGE_KEY)
      webengage?.options("safariWebPush", true)
      if (IS_LOCAL) {
        webengage?.debug(true)
      }
    }

    if (WEBENGAGE_KEY && !webengage) {
      console.log("WebEngage was not available")
    }
  }, [])

  return (
    <Sentry.ErrorBoundary
      fallback={
        <div
          style={{
            height: "calc(100vh - 16px)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column"
          }}
        >
          <p style={{ fontSize: "16px", marginBottom: 0 }}>
            An unexpected error occurred. Please try reloading the page.
          </p>

          <p style={{ fontSize: "13px", marginTop: "8px" }}>
            <span style={{ color: "#7D7D7D" }}>
              If the issue persists then please contact{" "}
            </span>
            <a href="mailto:care@suraasa.com">care@suraasa.com</a>
          </p>
        </div>
      }
    >
      <React.Fragment>
        <CssBaseline />
        <MuiThemeProvider theme={theme}>
          <GlobalCss />
          <Component {...pageProps} />
        </MuiThemeProvider>
      </React.Fragment>
    </Sentry.ErrorBoundary>
  )
}

MyApp.propTypes = {
  Component: PropTypes.elementType.isRequired,
  pageProps: PropTypes.object.isRequired
}

export default MyApp
